const DropdownSitemap = {
    _dropdowns: [],
    _sectionDropdownButtons: [],


    init() {
        let self = this;

        this._dropdowns = (document.querySelectorAll('.js-sitemap-dropdown'));

        if (this._dropdowns.length === 0) {
            return;
        }

        this._dropdowns.forEach((dropdown) => {
            self._dropdownConstruct(dropdown);
        })

        this._sectionDropdownButtons = (document.querySelectorAll('.js-sitemap-dropdown--button-section'));

        if (this._sectionDropdownButtons.length === 0) {
            return;
        }

        this._sectionDropdownButtons.forEach((button) => {
            self._sectionDropdownConstruct(button);
        })

    },

    _dropdownConstruct(dropdown) {
        let dropdownButton = dropdown.querySelector('.js-sitemap-dropdown--button');
        let dropdownContent = dropdown.querySelector('.js-sitemap-dropdown--content');
        dropdownButton.addEventListener('click', () => {
            if(dropdownContent.style.display === 'none') {
                dropdownContent.style.display = 'block';
                dropdownButton.style.rotate = '180deg';
            } else {
                dropdownContent.style.display = 'none';
                dropdownButton.style.rotate = '0deg';
            }
        });
    },

    _sectionDropdownConstruct(dropdownButton) {

        dropdownButton.addEventListener('click', () => {
            let sitemapList = dropdownButton.closest('div').nextElementSibling;
            if(sitemapList.style.display === 'none') {

                sitemapList.style.display = 'flex';
                dropdownButton.style.rotate = '180deg';
            } else {
                sitemapList.style.display = 'none';
                dropdownButton.style.rotate = '0deg';
            }
        });
    }
};

export { DropdownSitemap };